import { apiUrl } from 'libs/apiUrl';
import fetch from 'libs/fetchWithAuth';

const _baseUrl = apiUrl('/api/ext/qa');

class QA {
	static aiQuality(data, req) {
		return fetch(_baseUrl + '/ai-quality', { method: 'POST', body: JSON.stringify(data) }, req);
	}

	static checkTask(data, req) {
		return fetch(
			_baseUrl + '/check-task',
			{
				method: 'POST',
				body: JSON.stringify(data),
				throwOnHttpErrorStatus: true,
			},
			req
		);
	}

	static checkTasks(data, req) {
		return fetch(
			_baseUrl + '/check-tasks',
			{
				method: 'POST',
				body: JSON.stringify(data),
				throwOnHttpErrorStatus: true,
			},
			req
		);
	}

	static toggleIgnore(data, req) {
		return fetch(
			_baseUrl + '/toggle-ignore',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}

	static aiAssistantSegment(data, req) {
		return fetch(
			_baseUrl + '/ai-assistant/segment',
			{
				method: 'POST',
				body: JSON.stringify(data),
			},
			req
		);
	}
}

export default QA;
